import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// google reCaptcha
import ReCAPTCHA from 'react-google-recaptcha'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//API
import { bilgiDogrula } from '../../../apis/ogrenci';

const RegisterControl = () => {

    // google reCaptcha
    const recaptchaRef = React.createRef();
    const [recaptchaVerified, setRecaptchaVerified] = useState(false);
    const onChangeRecaptcha = (value) => {
        if (value) {
            setRecaptchaVerified(true);
        } else {
            setRecaptchaVerified(false);
        }
    };

    const navigate = useNavigate()

    //Refs
    const enstituRef = useRef()
    const tcRef = useRef()
    const dogumtarihiRef = useRef()

    //*******************************************STATES 
    const [enstitu, setEnstitu] = useState("")
    const [tc, setTc] = useState("")
    const [dogumtarihi, setDogumtarihi] = useState("")




    //********************************************HANDEL FUNCTIONS
    const handleFormControl = () => {

        if (enstitu === "") {
            enstituRef.current.focus()
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return toast.error("Lütfen enstitü seçiniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (tc === "" || tc.length !== 11) {
            tcRef.current.focus()
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return toast.error("Lütfen 11 haneli T.C. Kimlik numaranızı giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (dogumtarihi === "") {
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            dogumtarihiRef.current.focus()
            return toast.error("Doğum tarihinizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }
        //navigate('/register-control', { state: { enstitu: enstitu, tc: tc, dogumtarihi : dogumtarihi } })
        handleOgrenciBilgiDogrula()
    }

    const tarihCevirYOKSIS = (tarih) => {
        const dateParts = tarih.split('-');
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        return `${day}/${month}/${year}`
    }

    const handleOgrenciBilgiDogrula = async () => {
        let data = {
            tcNo: tc,
            yoksisId: enstitu,
            dogumTarihi: tarihCevirYOKSIS(dogumtarihi)
        }
        let result = await bilgiDogrula(data)
        if (result.status === 200) {
            navigate('/register-control', { state: { enstitu: enstitu, tc: tc, adSoyad: result.data[0].adSoyad, OgrenciNo: result.data[0].OgrenciNo, temporyToken : result.data[0].temporyToken } })
        } else {
            return toast.error(result?.response?.data.error.message, {
                position: toast.POSITION.TOP_LEFT
            });
        }
    }

    return (
        <>
            <ToastContainer />
            <div className='relative mx-auto w-full max-w-sm bg-white'>
                <div>
                    <img src={process.env.PUBLIC_URL + '/images/odu-yatay-color.png'} alt='Ordu Üniversitesi' className='h-16' />
                    <h2 className="text-2xl font-semibold  leading-6 mt-6 mb-2 text-slate-600"> Merhaba, </h2>
                    <p className="leading-6 text-sm text-slate-500 mb-6"> <strong>{process.env.REACT_APP_PROJECT_LOWER_NAME}</strong> Öğrenci Kayıt Ekranı</p>
                </div>
                <div className='mt-5'>
                    <div className='space-y-2'>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Kullanıcı Türü</label>
                            </div>
                            <div>
                                <select ref={enstituRef} onChange={e => setEnstitu(e.target.value)} className='sd-input'>
                                    <option value="">Enstitüsü seçiniz</option>
                                    <option value="122568">Fen Bilimleri Enstitüsü</option>
                                    <option value="122569">Sağlık Bilimler Enstitüsü</option>
                                    <option value="122570">Sosyal Bilimler Enstitüsü</option>
                                </select>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>TC Kimlik Numaranız</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={tcRef} onChange={(e) => setTc(e.target.value)} type='text' placeholder='11 haneli vatandaşlık numaranız' className='sd-input' />
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Doğum Tarihiniz</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={dogumtarihiRef} onChange={(e) => setDogumtarihi(e.target.value)} type='date' placeholder='Doğum tarihiniz' pattern="\d{2}/\d{2}/\d{4}" className='sd-input' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4 flex items-center justify-between'>
                        <div>
                            <Link to={'/login'} className='text-slate-600 font-semibold text-xs hover:underline'>Giriş yap</Link>
                        </div>
                        <div>
                            <Link to={'/forget-password'} className='text-slate-600 font-semibold text-xs hover:underline'>Şifremi Unuttum!</Link>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <ReCAPTCHA
                            className='mb-4'
                            ref={recaptchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                            onChange={(value) => onChangeRecaptcha(value)} />
                        <button disabled={!recaptchaVerified} onClick={() => handleFormControl()} className='text-white disabled:bg-slate-400 disabled:hover:bg-slate-400 bg-slate-600 hover:bg-slate-600/80 h-12 leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1 transition-all duration-150'>Bilgilerimi getir</button>
                    </div>
                    <div className='w-full mt-8 text-sm text-slate-400 text-center'>Bilgi İşlem Daire Başkanlığı {new Date().getFullYear()}</div>
                </div>
            </div>
        </>
    );
}

export default RegisterControl;
